// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26J2n","name":"styles_name__2HuEm","phone":"styles_phone__1IoMN"};